(function() {
  define('bazemont/documents/list',['angular'], function() {
    'use strict';
    return angular.module('bazemontDocumentsList', []).component('bazemontDocumentsList', {
      templateUrl: '/assets/javascripts/bazemont/documents/list.html',
      bindings: {
        documents: '=',
        nbColumns: '<'
      },
      require: {
        s3Uploader: '^^tlhS3Uploader'
      },
      controller: [
        '$scope', 'TlhConfirmModalService', 'TlhGridClassService', 'TlhPositionService', function($scope, TlhConfirmModalService, TlhGridClassService, TlhPositionService) {
          var vm;
          vm = this;
          vm.columnClass = TlhGridClassService.getColumnClass(vm.nbColumns);
          vm.getNbDocuments = function() {
            var document, nbDocuments, _i, _len, _ref;
            nbDocuments = 0;
            if (vm.documents) {
              _ref = vm.documents;
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                document = _ref[_i];
                if (document.isActive) {
                  nbDocuments++;
                }
              }
            }
            return nbDocuments;
          };
          vm.moveDocumentUp = function(document) {
            return TlhPositionService.moveElementUp(document, vm.documents);
          };
          vm.moveDocumentDown = function(document) {
            return TlhPositionService.moveElementDown(document, vm.documents);
          };
          vm.trashAllDocuments = function() {
            var message;
            message = '<p class="text-center">Êtes-vous sûr(e) de vouloir supprimer tous les documents ?</p>';
            return TlhConfirmModalService.open(message).result.then(function(result) {
              var document, _i, _len, _ref, _results;
              if (result.confirm) {
                _ref = vm.documents;
                _results = [];
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                  document = _ref[_i];
                  _results.push(document.isActive = false);
                }
                return _results;
              }
            });
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=list.js.map
;
